import { ImageRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasImagePicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasImagePicker } from "./image-picker";

let loadImagePick = !1;

export function bindImageCanvasPickerContribution(container) {
    loadImagePick || (loadImagePick = !0, container.bind(CanvasImagePicker).toDynamicValue((() => new DefaultCanvasImagePicker(resolveContainerBinding(container, ImageRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasImagePicker));
}
//# sourceMappingURL=image-module.js.map
